import { useCallback } from "react";
import _ from "lodash";

/**
 * Handles onSelectedChange callback for string-based IDs
 * Persists selection across pagination
 * @param selectedItems - Currently selected item IDs
 * @param setSelectedItems - Setter for selected items
 */
export const useSelectedStringItemsChanges = (
  selectedItems: string[],
  setSelectedItems: (newItems: string[]) => void
) =>
  useCallback(
    (id: string | string[]) => {
      if (Array.isArray(id)) {
        // handleSelectAllClick šalje puni željeni skup (unija/filter po stranici) → replace.
        setSelectedItems(id);
        return;
      }

      const isIdAlreadySelected = selectedItems.includes(id);
      if (!isIdAlreadySelected) {
        setSelectedItems([...selectedItems, id]);
        return;
      }

      setSelectedItems(_.without(selectedItems, id));
    },
    [selectedItems, setSelectedItems]
  );

/**
 * Handles select all on current page while preserving selections from other pages
 * @param currentPageIds - IDs of items on current page
 * @param selectedItems - All currently selected item IDs
 * @param setSelectedItems - Setter for selected items
 */
export const useSelectAllOnPage = (
  currentPageIds: string[],
  selectedItems: string[],
  setSelectedItems: (newItems: string[]) => void
) =>
  useCallback(
    (selectAll: boolean) => {
      if (selectAll) {
        // Add all current page items to selection
        const newSelection = [...new Set([...selectedItems, ...currentPageIds])];
        setSelectedItems(newSelection);
      } else {
        // Remove only current page items from selection
        setSelectedItems(selectedItems.filter((id) => !currentPageIds.includes(id)));
      }
    },
    [currentPageIds, selectedItems, setSelectedItems]
  );
